export default __webpack_public_path__ + "static/media/about_paper_03.8fb79854.png";